<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'MED_REVIEW.ASSIGN_STANDARD' | translate }}</h3>
    </div>
  </div>
  <div class="card-body">
    <form [formGroup]="form" class="form form-group mb-0">
      <kt-general-autocomplete
        [label]="'Program'"
        [dataPath]="'data'"
        [loadItemsFunction]="getProgramAutocomplete"
        [optionFormatter]="formatProgramOption"
        [valueFormatter]="formatProgramOption"
        [control]="form.get('program')"
        [change]="onProgramChange.bind(this)"
        [required]="true"
        [readOnly]="false"
        [class]="'mb-4'"
      ></kt-general-autocomplete>
      <kt-general-autocomplete
        [label]="'Standards'"
        [loadItemsFunction]="getStandardAutocomplete"
        [optionFormatter]="formatStandardOption"
        [valueFormatter]="formatStandardOption"
        [formatNewObjectFn]="formatNewStandard"
        [control]="form.get('standards')"
        [objects]="form.get('standards').value"
        [change]="onStandardChange.bind(this)"
        [required]="false"
        [readOnly]="!form.get('program').value"
        [chipList]="true"
        [dataPath]="'data'"
      ></kt-general-autocomplete>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      type="button"
      mat-raised-button
      cdkFocusInitial
      style="width: 75px"
      class="mr-4"
      (click)="onClose($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      style="width: 75px"
      [disabled]="form.invalid"
      (click)="onSubmit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
